// use https://jakearchibald.github.io/svgomg/
// use https://yoksel.github.io/url-encoder/

import SvgFullscreenExit from "~/components/svgs/SvgFullscreenExit";
import SvgFullscreen from "~/components/svgs/SvgFullscreen";
import SvgSoundOff from "~/components/svgs/SvgSoundOff";
import SvgPause from "~/components/svgs/SvgPause";
import SvgPlay from "~/components/svgs/SvgPlay";
import SvgSoundOn from "~/components/svgs/SvgSoundOn";
import SvgCC from "~/components/svgs/SvgCC";

const svgs: Record<string, string> = {
  play: SvgPlay,
  pause: SvgPause,
  fullscreenOn: SvgFullscreen,
  fullscreenOff: SvgFullscreenExit,
  mute: SvgSoundOff,
  unmute: SvgSoundOn,
  cc: SvgCC,

};

export const PlayerSVGs = (key: string) => {
  if (key in svgs)
    return svgs[key];

  return '%3Csvg xmlns="http://www.w3.org/2000/svg" fill="%23000" viewBox="0 0 33 33"%3E%3C/svg%3E';
}

